export default {"src":"/_next/static/media/mt-benefit-1.2c196ce6.svg","height":221,"width":555,"blurWidth":0,"blurHeight":0};